export const IS_ONE_DIGIT = /^[0-9]$/g;